import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Button,
  Box,
  Alert,
  AlertIcon,
  Stack
} from '@chakra-ui/react';

const ForgotPasswordModal = ({ show, onClose }) => {
  const [email, setEmail] = useState('');
  const { requestPasswordReset, loading, error, success } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await requestPasswordReset(email);
  };

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setEmail('');
        onClose();
      }, 1500);
    }
  }, [success, onClose]);

  return (
    <Modal isOpen={show} onClose={onClose} isCentered>
      <ModalOverlay backdropFilter="blur(10px)" bg="blackAlpha.600" />
      <ModalContent
        bg="linear-gradient(135deg, rgba(10, 10, 31, 0.95) 0%, rgba(26, 10, 46, 0.95) 100%)"
        borderRadius="2xl"
        border="1px solid"
        borderColor="whiteAlpha.200"
        boxShadow="0 8px 32px rgba(0, 0, 0, 0.4)"
      >
        <ModalHeader
          fontSize="2xl"
          fontWeight="bold"
          bgGradient="linear(to-r, #667eea, #764ba2)"
          bgClip="text"
        >
          Reset Password
        </ModalHeader>
        <ModalCloseButton color="whiteAlpha.800" _hover={{ bg: 'whiteAlpha.200' }} />
        <ModalBody pb={6}>
          <Box as="form" onSubmit={handleSubmit}>
            <Stack spacing={4}>
              {error && (
                <Alert status="error">
                  <AlertIcon />
                  {error}
                </Alert>
              )}
              {success && (
                <Alert status="success">
                  <AlertIcon />
                  Password reset email sent!
                </Alert>
              )}
              <FormControl isRequired>
                <FormLabel fontWeight="medium" color="whiteAlpha.900">Email</FormLabel>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  isDisabled={loading}
                  placeholder="Enter your email address"
                  size="md"
                  color="white"
                  bg="whiteAlpha.100"
                  borderColor="purple.500"
                  _placeholder={{ color: "whiteAlpha.500" }}
                  _hover={{ bg: "whiteAlpha.150", borderColor: "purple.400" }}
                  _focus={{ bg: "whiteAlpha.150", borderColor: "purple.300", boxShadow: "0 0 0 1px rgba(102, 126, 234, 0.6)" }}
                />
              </FormControl>
              <Button
                mt={6}
                bgGradient="linear(to-r, #667eea, #764ba2)"
                _hover={{
                  bgGradient: "linear(to-r, #764ba2, #667eea)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 15px rgba(102, 126, 234, 0.6)"
                }}
                type="submit"
                isLoading={loading}
                loadingText="Sending"
                isFullWidth
                size="md"
                fontWeight="bold"
                mb={4}
                color="white"
              >
                Send Reset Link
              </Button>
            </Stack>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ForgotPasswordModal;